import util from '@bmp-vue/core/api/util'

const controller = 'ProjetoInformacoes'
export default Object.assign({}, util.GetCrud(controller, null), {
  FormularioTipoLayout: [
    { text: 'CCB', value: 1 },
    { text: 'CCBSandbox', value: 10 },
    { text: 'Cessao', value: 2 },
    { text: 'CessaoSandbox', value: 20 },
    { text: 'Contrato', value: 3 },
    { text: 'ContratoSandbox', value: 30 }
  ]
})
